import { Injectable } from "@angular/core";
import { IUserAddress } from "../../shared/models/userAddress.model";

export interface AddressLineVM {
    text: string;
    isDifferent: boolean;
}

export interface AddressCompareVM {
    entered: { line1: AddressLineVM; line2: AddressLineVM };
    suggested: { line1: AddressLineVM; line2: AddressLineVM };
}

@Injectable()
export class OrderAddressQueryService {

    public buildCompareVm(entered: IUserAddress, suggested: IUserAddress): AddressCompareVM {
        const e = this.normalizeAddress(entered);
        const s = this.normalizeAddress(suggested);

        const eLine1 = `${e.street} ${e.houseNumber}`.trim();
        const sLine1 = `${s.street} ${s.houseNumber}`.trim();
        const eLine2 = `${e.zipCode} ${e.city}`.trim();
        const sLine2 = `${s.zipCode} ${s.city}`.trim();

        return {
            entered: {
                line1: { text: eLine1, isDifferent: !this.equalsLoosely(eLine1, sLine1) },
                line2: { text: eLine2, isDifferent: !this.equalsLoosely(eLine2, sLine2) },
            },
            suggested: {
                line1: { text: sLine1, isDifferent: !this.equalsLoosely(sLine1, eLine1) },
                line2: { text: sLine2, isDifferent: !this.equalsLoosely(sLine2, eLine2) },
            }
        };
    }

    private equalsLoosely(a: string, b: string): boolean {
        return this.normalizeText(a) === this.normalizeText(b);
    }

    private normalizeText(s: string): string {
        if (!s) return "";
        return s.toLowerCase().replace(/\s+/g, " ").trim();
    }

    private normalizeAddress(a: IUserAddress): IUserAddress {
        return {
            street: (a && a.street) ? a.street : "",
            houseNumber: (a && a.houseNumber) ? a.houseNumber : "",
            zipCode: (a && a.zipCode) ? a.zipCode : "",
            city: (a && a.city) ? a.city : "",
            streetAndHouseNumber: ""
        } as IUserAddress;
    }
}
